import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';

const SPONSORHIPS_REQ_API = environment.platformEndpoint;

@Injectable({
  providedIn: 'root'
})
export class SponsorshipRequestService {

  private sponsorshipReqApi = SPONSORHIPS_REQ_API + "/sponsorships/requests";

  constructor(private http: HttpClient) { }

  getSponsorshipRequestByStatus(owner: any){
    let header = this.createRequestHeader();
    return this.http.get<any>(this.sponsorshipReqApi+"?owner="+owner, {headers: header});
  }

  createSponsorshipRequest(sponsorshipReq: any){
    let header = this.createRequestHeader();

    return this.http.post<any>(this.sponsorshipReqApi, sponsorshipReq, {headers: header});
  }

  deleteSponsorshipReq(sponsorshipReq: any){
    let header = this.createRequestHeader();

    const options = {
      headers: header,
      body: {
        sponsorId: sponsorshipReq.sponsorId
      },
    };

    return this.http.delete<any>(this.sponsorshipReqApi+"/"+sponsorshipReq.sponsorshipRequestId,  options);
  }

  updateSponsorshipReq(sponsorshipReq: any){
    let header = this.createRequestHeader();
    return this.http.put<any>(this.sponsorshipReqApi+"/"+sponsorshipReq.sponsorshipRequestId, sponsorshipReq, {headers: header});
  }

  private createRequestHeader() {
    let headers = new HttpHeaders();

    headers.set('Content-Type', 'application/json');
    headers.set('Access-Control-Allow-Origin', '*');
    return headers;
  }
}
